// Get the modal
var modal = document.getElementById('uiModal');

// Get the <span> element that closes the modal
var closeBtn = document.getElementsByClassName('close')[0];

// When the user clicks on <span> (x), close the modal
closeBtn.onclick = function () {
  modal.style.display = 'none';
};

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = 'none';
  }
};

function closeUIModal() {
  var modal = document.getElementById('uiModal');
  modal.style.display = 'none';
}

// Function to open the modal with dynamic content
function openUIModal(content) {
  var modal = document.getElementById('uiModal');
  var modalContent = document.getElementById('modalContent');

  // Populate modal with dynamic content
  modalContent.innerHTML = content;

  // Display the modal
  modal.style.display = 'block';
}
